import React from 'react'
import FlexView from 'react-flexview/lib'
import { OptionalTag } from '../../Core/OptionalTag'
import {
  Grid,
  Accordion,
  IconButton,
  AccordionSummary,
  AccordionDetails,
  Divider,
  FormControlLabel,
  Radio,
  Checkbox,
  FormLabel,
} from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { AdditionalPopover } from '../../Core/Popover/AdditionalInsuredPopover'
import { RequesetSupportTag } from '../../Core/RequestSupportTag'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import {
  BuyingInsuranceContextStore,
  OFFERS_ACTIONS,
} from '../../../context/BuyingInsuranceContext'
import { SessionService } from '../../../services/SessionService'
import { WorldWideOption } from '../../../models/insurance-models/WorldWideOption'
import {
  EventEmitterService,
  EventKey,
} from '../../../services/EventEmitterService'
import { WorldWideCoverageeDetailsPopup } from '../../PopUps/WorldWideCoverageDetailsPopup'
import DoneIcon from '@material-ui/icons/Done'
import DataLayerService from '../../../services/DataLayerService'
import { AdditionalCoveragesPopover } from '../../Core/Popover/AdditionalCoveragesPopover'
import { PersonalInjuryPopover } from '../../Core/Popover/PersonalInjuryPopover'
import { MedicalExpensesPopover } from '../../Core/Popover/MedicalExpensesPopover'
import { WorldWidePopover } from '../../Core/Popover/WorldWidePopover'
import { SpecialPriceSection } from './SpecialPriceSection'
import { isCanada, isUK } from '../../../services/utils'
import { IndoorCoveragePopup } from '../../PopUps/IndoorCoveragePopup'
import { IndoorCoveragePopover } from '../../Core/Popover/IndoorCoveragePopover'

var classNames = require('classnames')

export const CustomizeAdditionalCoverageSection = () => {
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [expanded, setExpanded] = React.useState(false)
  const toggleExpand = () =>
    setExpanded(!expanded) ||
    DataLayerService.pushToDataLayer({
      event: 'additional-coverages-read-more-click',
    })

  const changePersonalInjury = (event) =>
    offersContext.changePersonalInjury(event.target.value)
  const changeMedicalExpenseLimit = (event) =>
    offersContext.changeMedicalExpenseLimit(event.target.value)

  const includeWW = () => {
    if (
      offersContext.worldWideCoverage.territorialLimits ==
      WorldWideOption.Worldwide
    )
      offersContext.flipWorldWideCoverage(
        WorldWideOption.Default,
        offersContext.worldWideCoverage.territorialLimitsDescription
      )
    else
      offersContext.flipWorldWideCoverage(
        WorldWideOption.Worldwide,
        offersContext.worldWideCoverage.territorialLimitsDescription
      )
    // EventEmitterService.dispatch(EventKey.SHOW_WW_DETAILS_POPUP, {
    //     description: offersContext.worldWideCoverage.territorialLimitsDescription,
    //     limits: WorldWideOption.Worldwide
    // })
  }

  const includeCustomWW = () => {
    if (
      offersContext.worldWideCoverage.territorialLimits ==
      WorldWideOption.Custom
    )
      offersContext.flipWorldWideCoverage(
        WorldWideOption.Default,
        offersContext.worldWideCoverage.territorialLimitsDescription
      )
    else
      offersContext.flipWorldWideCoverage(
        WorldWideOption.Custom,
        offersContext.worldWideCoverage.territorialLimitsDescription
      )
    // EventEmitterService.dispatch(EventKey.SHOW_WW_DETAILS_POPUP, {
    //     description: offersContext.worldWideCoverage.territorialLimitsDescription,
    //     limits: WorldWideOption.Custom
    // })
  }

  const includeIndoors = () => {
    if (offersContext.indoorCoverage.included)
      offersContext.dispatch({
        type: OFFERS_ACTIONS.SET_INDOOR_COVERAGE,
        data: {
          included: false,
          description: offersContext.indoorCoverage.description,
        },
      })
    else
      EventEmitterService.dispatch(
        EventKey.SHOW_INDOORS_DETAILS_POPUP,
        offersContext.indoorCoverage.description
      )
  }

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.WW_DETAILS_POPUP_APPROVE,
      (data) => {
        offersContext.flipWorldWideCoverage(data.limits, data.description)
      }
    )

    let id2 = EventEmitterService.subscribe(
      EventKey.INDOORS_POPUP_APPROVE,
      (data) => {
        offersContext.dispatch({
          type: OFFERS_ACTIONS.SET_INDOOR_COVERAGE,
          data: { included: true, description: data.description },
        })
      }
    )

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.WW_DETAILS_POPUP_APPROVE, id)
      EventEmitterService.unsubscribe(EventKey.INDOORS_POPUP_APPROVE, id2)
    }
  }, [offersContext.worldWideCoverage, offersContext.indoorCoverage])

  return (
    <>
      <FlexView
        vAlignContent={'center'}
        className="space-between margin-top-basic">
        <FlexView vAlignContent={'center'}>
          <div className="text-body bold black">Add Additional Coverages </div>
          <AdditionalCoveragesPopover />
        </FlexView>
        <OptionalTag />
      </FlexView>

      <FlexView
        onClick={toggleExpand}
        className="space-between"
        vAlignContent={'center'}>
        <div className="text-body gray section-details-overflow">
          Upgrade your coverage - indoors, worldwide, higher personal injury and
          medical expense are available
        </div>
        <FlexView vAlignContent={'center'}>
          {!isMobile && (
            <div className="text-body gray clickable">Explore Coverages</div>
          )}
          <IconButton onClick={toggleExpand}>
            <ExpandMoreIcon
              className={classNames('fa-arrow-down', {
                open: expanded,
              })}
            />
          </IconButton>
        </FlexView>
      </FlexView>

      <Accordion
        id={'addi-cover'}
        className="transparent"
        elevation={0}
        expanded={expanded}>
        <AccordionSummary
          className="unset-cursor"
          style={{ display: 'none' }}
        />
        <AccordionDetails>
          <div>
            {!isUK() && (
              <>
                <FlexView vAlignContent={'center'} className="margin-bottom-6">
                  <div className="text-body bold black">Indoors Coverage</div>
                  <IndoorCoveragePopover />
                </FlexView>

                <FormControlLabel
                  label="Include indoor coverage"
                  control={
                    <Checkbox
                      onClick={includeIndoors}
                      color="primary"
                      checked={offersContext.indoorCoverage.included}
                    />
                  }
                />

                <Divider />
              </>
            )}

            <FlexView vAlignContent={'center'} className="margin-bottom-6">
              <div className="text-body bold black">
                Personal Injury Coverage (Including Privacy)
              </div>
              <PersonalInjuryPopover />
            </FlexView>

            {FirebaseService.getArray(
              FirebaseConfigKey.PERSONAL_INJURY_COVERAGE
            ).map((personalInj, index) => (
              <FormControlLabel
                key={index}
                label={`${FirebaseService.getValue(
                  FirebaseConfigKey.CURRENCY_SYMBOL
                )}${personalInj.toLocaleString()} ${
                  index == 0 ? ' (Included)' : ''
                }`}
                onChange={changePersonalInjury}
                checked={offersContext.personalInjuryCoverage == personalInj}
                value={personalInj}
                control={
                  <Radio
                    className={classNames({
                      gray: index == 0,
                    })}
                    color="primary"
                  />
                }
              />
            ))}

            <Divider />

            <FlexView vAlignContent={'center'} className="margin-bottom-6">
              <div className="text-body bold black">Medical Expense</div>
              <MedicalExpensesPopover />
            </FlexView>

            {FirebaseService.getArray(FirebaseConfigKey.MEDICAL_EXPENSES).map(
              (medicalExpenseLimit, index) => (
                <FormControlLabel
                  key={index}
                  label={`${FirebaseService.getValue(
                    FirebaseConfigKey.CURRENCY_SYMBOL
                  )}${medicalExpenseLimit.toLocaleString()} ${
                    index == 0 ? ' (Included)' : ''
                  }`}
                  onChange={changeMedicalExpenseLimit}
                  checked={offersContext.medicalExpense == medicalExpenseLimit}
                  value={medicalExpenseLimit}
                  control={
                    <Radio
                      className={classNames({
                        gray: index == 0,
                      })}
                      color="primary"
                    />
                  }
                />
              )
            )}

            <Divider />

            <FlexView vAlignContent={'center'} className="margin-bottom-6">
              <div className="text-body bold black">Worldwide Coverage</div>
              <WorldWidePopover />
            </FlexView>
            {isCanada() && (
              <>
                <div className="text-body gray margin-top-6 black">
                  SkyWatch.AI's standard coverage territory is anywhere in
                  Canada
                </div>
                <br />
              </>
            )}

            {SessionService.isAdmin() && (
              <>
                <FormControlLabel
                  label="Include worldwide coverage"
                  control={
                    <Checkbox
                      onClick={includeWW}
                      color="primary"
                      checked={
                        offersContext.worldWideCoverage.territorialLimits ==
                        WorldWideOption.Worldwide
                      }
                    />
                  }
                />
              </>
            )}

            {isCanada() && (
              <>
                <FormControlLabel
                  label="Include coverage in the US"
                  control={
                    <Checkbox
                      onClick={includeCustomWW}
                      color="primary"
                      checked={
                        offersContext.worldWideCoverage.territorialLimits ==
                        WorldWideOption.Custom
                      }
                    />
                  }
                />
              </>
            )}

            {!SessionService.isAdmin() &&
              offersContext.worldWideCoverage.territorialLimits ==
                WorldWideOption.Default && (
                <RequesetSupportTag
                  tag={'worldwide'}
                  text={FirebaseService.getValue(
                    FirebaseConfigKey.WORLD_WIDE_TEXT
                  )}
                />
              )}

            {offersContext.worldWideCoverage.territorialLimits !=
              WorldWideOption.Default && (
              <>
                <div className="text-body margin-top-small gray">
                  {offersContext.worldWideCoverage.territorialLimitsDescription}
                </div>
                <FlexView
                  className="green margin-top-small text-body"
                  vAlignContent={'center'}>
                  <DoneIcon className="green margin-right-3" />
                  {offersContext.worldWideCoverage.territorialLimits ==
                    WorldWideOption.Custom && 'Coverage in the US is included'}
                  {offersContext.worldWideCoverage.territorialLimits ==
                    WorldWideOption.Worldwide &&
                    'Worldwide coverage is included'}
                </FlexView>
              </>
            )}

            {SessionService.isAdmin() && (
              <>
                <Divider />
                <SpecialPriceSection />
              </>
            )}
          </div>
        </AccordionDetails>
      </Accordion>

      <br />

      <WorldWideCoverageeDetailsPopup />
      <IndoorCoveragePopup />
    </>
  )
}
